import { DATA_KEYS, readJSON, writeJSON } from "@/storage/local";

export const MUSCLE_GROUPS = [
  "Pecho", "Espalda", "Hombros", "Bíceps", "Tríceps", "Antebrazos", "Trapecio",
  "Abdominales", "Cuádriceps", "Isquiotibiales", "Glúteos", "Gemelos", "Piernas", "Otros",
];

const DEFAULT_GOAL = 45;

export function loadWeeklyGoal() {
  const value = readJSON(DATA_KEYS.WEEKLY_GOAL, null);
  return typeof value === "number" && value > 0 ? value : DEFAULT_GOAL;
}

export function saveWeeklyGoal(value) {
  writeJSON(DATA_KEYS.WEEKLY_GOAL, value);
}

// Los grupos musculares de la rutina son texto libre ("Pecho/Tríceps",
// "Hombro posterior", "Cuádriceps"), así que hay que normalizarlos a los
// grupos del mapa corporal antes de poder sumar series.
export function normalizeGroup(raw) {
  const t = (raw || "").toLowerCase().trim();
  if (!t) return null;
  if (t.includes("pecho") || t.includes("pector")) return "Pecho";
  if (t.includes("trapec")) return "Trapecio";
  if (t.includes("espalda") || t.includes("dorsal")) return "Espalda";
  if (t.includes("hombro") || t.includes("delt")) return "Hombros";
  if (t.includes("bíceps") || t.includes("biceps")) return "Bíceps";
  if (t.includes("tríceps") || t.includes("triceps")) return "Tríceps";
  if (t.includes("antebrazo")) return "Antebrazos";
  if (t.includes("abdomin") || t.includes("oblicuo") || t.includes("core")) return "Abdominales";
  if (t.includes("cuádriceps") || t.includes("cuadriceps")) return "Cuádriceps";
  if (t.includes("isquio")) return "Isquiotibiales";
  if (t.includes("glúteo") || t.includes("gluteo")) return "Glúteos";
  if (t.includes("gemelo") || t.includes("pantorrilla")) return "Gemelos";
  if (t.includes("pierna")) return "Piernas";
  return "Otros";
}

// "Pecho/Tríceps" trabaja los dos, así que cuenta para ambos.
export function groupsOf(raw) {
  if (!raw) return ["Otros"];
  const groups = raw.split(/[/,]/).map(normalizeGroup).filter(Boolean);
  return groups.length > 0 ? [...new Set(groups)] : ["Otros"];
}

// Series completadas por grupo muscular en la rutina actual.
export function seriesByGroup(routine, progress) {
  const counts = {};

  routine.forEach((day, dIdx) => {
    day.exercises.forEach((ex) => {
      const groups = groupsOf(ex.muscleGroup);
      for (let s = 0; s < ex.sets; s++) {
        if (!progress[`${dIdx}-${ex.id}-${s}`]?.done) continue;
        groups.forEach((g) => {
          counts[g] = (counts[g] || 0) + 1;
        });
      }
    });
  });

  return counts;
}

// Intensidad de 0 a 1 por grupo, para colorear el mapa corporal. Se normaliza
// contra el grupo más entrenado: interesa ver el desequilibrio entre músculos,
// no cuántas series son en absoluto.
export function groupIntensity(counts) {
  const max = Math.max(0, ...Object.values(counts));
  if (max === 0) return {};

  const intensity = {};
  for (const [group, count] of Object.entries(counts)) {
    intensity[group] = count / max;
  }
  return intensity;
}
